<template>


</template>

<script>
import {
    mapGetters,
    mapActions,
    mapState
} from 'vuex'
import {
    UserItem,
    Notificacion,
    Navbar,
    Footer,
    LeftSidebar,
    Comentarios
} from '@/components/layout'

export default {
    components: {
        UserItem,
        LeftSidebar,
        Notificacion,
        Navbar,
        Comentarios,
        Footer
    },
    mounted() {
        console.log(this.$vuetify.breakpoint.name)
    },
    computed: {
        ...mapGetters('oidc', [
            'oidcUser', 'oidcAccessToken'
        ]),
        ...mapState({
            categorias: state => state.categorias,
            access_token: state => state.oidc.id_token
        }),

    },

    watch: {},
    data() {
        return {
            menuIzMin: false,
            drawerRight: true,
            collapseOnScroll: false,
            drawer: null,
            ventana: 1,
            comentarios: false,
            left: false,
            right: false
        }
    },
    methods: {
        ...mapActions({
            signOutOidc: 'oidc/signOutOidc',
            getCategorias: 'getCategorias'
        }),

        closeSidebar() {
            this.left = !this.left
        }

    }
}

</script>

<style>
#eltool {
    border-radius: 0px 0px 0px 15px;
    -moz-border-radius: 0px 0px 0px 15px;
    -webkit-border-radius: 0px 0px 0px 15px;
    border: 0px solid #000000;
}

.v-toolbar__content {
    padding-left: 9px !important;
    padding-right: 9px !important;
}

.theme--light.v-navigation-drawer:not(.v-navigation-drawer--floating) .v-navigation-drawer__border {
    background-color: transparent !important;
}

#menuIzq {
    -webkit-box-shadow: 0px 0px 12px 2px rgba(0, 0, 0, 0.13);
    -moz-box-shadow: 0px 0px 12px 2px rgba(0, 0, 0, 0.13);
    box-shadow: 0px 0px 12px 2px rgba(0, 0, 0, 0.13);
}
</style>
